export default __webpack_public_path__ + "static/media/chevron_down_complementary.da36d03a.svg";